import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteOrcamento() {
    return useMutation(
      '/v1/orcamento',
      async (id: string) => {
        const {data} = await http.delete(`/v1/orcamento/${id}`);
        return data as {id: string};
      },
      { retry: false }
    );
  }
  
  export default useDeleteOrcamento;
  